import { DateTimePicker, DateTimePickerProps, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { PickerValue } from "@mui/x-date-pickers/internals";
import { isValid } from "date-fns";
import { ForwardedRef, forwardRef, JSX, useEffect, useState } from "react";

function DefaultDateTimePicker({
    value,
    onChange,
    ...props
}: DateTimePickerProps, ref?: ForwardedRef<HTMLDivElement>): JSX.Element   {
    const [valueBuffer, setValueBuffer] = useState<PickerValue>(value ?? null);

    useEffect(() => {
        setValueBuffer(value ?? null);
    }, [value]);
    
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
                ref={ref}
                {...props}
                value={valueBuffer}
                onChange={(date, context) => {
                    if(isValid(date)){
                        setValueBuffer(date);
                        onChange?.(date, context);
                    }
                }}
            />
        </LocalizationProvider>
    );
}

export default forwardRef(DefaultDateTimePicker);